import { getTenants, getTenantInfo, createTenant, deleteTenant, updateTenant } from "@/apis";
import { processResponse } from "./_helper";

export const RESOURCE_TYPE_TENANTS = 'tenants';

export const TenantsDataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    const response = await getTenants();
    const data = response.value;
    return {
      data,
      total: data.length,
    };
  },
  getOne: async ({ id, meta }) => {
    const response = await getTenantInfo(id, meta);
    return processResponse(response);
  },
  create: async ({ resource, variables, meta }) => {
    const response = await createTenant(variables);
    return processResponse(response);
  },
  update: async ({ resource, id, variables }) => {
    const response = await updateTenant(variables?.data);
    return processResponse(response);
  },
  deleteOne: async ({ id }) => {
    const resp = await deleteTenant(id);
    return resp.value;
  },
  getApiUrl: () => {
    throw new Error("Function not implemented.");
  },
};